function isFieldError(value: unknown): value is Record<string, unknown> {
  return Boolean(
    value &&
      typeof value === 'object' &&
      ('type' in value || 'message' in value || 'types' in value),
  );
}

function collectErrorPaths(
  value: unknown,
  path: string,
  instanceIndex?: number,
  instanceSelected = false,
): string[] {
  if (Array.isArray(value)) {
    if (instanceIndex !== undefined && !instanceSelected) {
      return collectErrorPaths(
        value[instanceIndex],
        `${path}.${instanceIndex}`,
        instanceIndex,
        true,
      );
    }
    return value.flatMap((item, index) =>
      collectErrorPaths(item, `${path}.${index}`, instanceIndex, instanceSelected),
    );
  }
  if (isFieldError(value)) return path ? [path] : [];
  if (value && typeof value === 'object') {
    return Object.entries(value).flatMap(([name, nestedValue]) =>
      collectErrorPaths(
        nestedValue,
        path ? `${path}.${name}` : name,
        instanceIndex,
        instanceSelected,
      ),
    );
  }
  return [];
}

export function getBlockFormErrorPaths(
  namespace: string,
  namespaceErrors: unknown,
  formFieldNames: string[],
  instanceIndex?: number,
): string[] {
  const configuredNames = new Set(formFieldNames.map((name) => name.split('.').pop()!));
  const paths = collectErrorPaths(namespaceErrors, namespace, instanceIndex);
  if (!configuredNames.size) return paths;

  return paths.filter((path) => configuredNames.has(path.split('.').pop()!));
}
